export enum AntragsType {
  UNDEFINED = 0, // Default, wenn nicht spezifiziert bzw. 0 oder null
  KURZANTRAG = 1, // Antrag ist ein Kurzantrag (only legacy Einreichung)
  LANGANTRAG = 2, // Antrag ist ein Langantrag (only new Einreichung)
  LANGANTRAG_LEGACY = 3, // Antrag ist ein Legacy-Langantrag (only legacy Einreichung)
}
